// All multilingual content. Each value is { zh, en, zhTW, ja, ko, vi }.
// Reading: t(strings.foo.bar) where t = (obj) => obj[lang] ?? obj.en ?? obj.zh.
// Missing fields fall through to en, then zh.

export const UI = {
  nav: {
    spirit: {
      zh: '梭哈精神',
      en: 'Spirit',
      zhTW: '梭哈精神',
      ja: 'オールイン精神',
      ko: '올인 정신',
      vi: 'Tinh thần',
    },
    quotes: {
      zh: '大佬语录',
      en: 'Quotes',
      zhTW: '大佬語錄',
      ja: '名言',
      ko: '어록',
      vi: 'Trích dẫn',
    },
    stories: {
      zh: '梭哈故事',
      en: 'Stories',
      zhTW: '梭哈故事',
      ja: 'ストーリー',
      ko: '스토리',
      vi: 'Câu chuyện',
    },
    chart: {
      zh: '行情',
      en: 'Chart',
      zhTW: '行情',
      ja: 'チャート',
      ko: '차트',
      vi: 'Biểu đồ',
    },
    buy: {
      zh: '立即购买 →',
      en: 'Buy Now →',
      zhTW: '立即購買 →',
      ja: '今すぐ購入 →',
      ko: '지금 구매 →',
      vi: 'Mua ngay →',
    },
  },
  hero: {
    tag: {
      zh: '已上线 BNB 链 · 由社区共识驱动',
      en: 'Live on BNB Chain · Driven by community',
      zhTW: '已上線 BNB 鏈 · 由社群共識驅動',
      ja: 'BNB チェーンで稼働中 · コミュニティ・コンセンサス駆動',
      ko: 'BNB 체인에서 운영 중 · 커뮤니티 합의 기반',
      vi: 'Đã lên BNB Chain · Vận hành bởi đồng thuận cộng đồng',
    },
    title1: {
      zh: '看懂了，',
      en: 'See it.',
      zhTW: '看懂了，',
      ja: '見極めたら、',
      ko: '꿰뚫어 봤다면,',
      vi: 'Thấy rõ rồi,',
    },
    title2: {
      zh: '就梭哈。',
      en: 'Bet it all.',
      zhTW: '就梭哈。',
      ja: '全部行け。',
      ko: '올인하라.',
      vi: 'đặt tất cả.',
    },
    lead: {
      zh:
        'ALLIN 是属于梭哈者的社区共识币。这里收录那些把全部押了上去的人——他们的故事、他们的精神、他们的语录。没有团队承诺，没有路线图魔法，只有一群信仰"看懂之后就梭哈"的人，把筹码推到了桌子中央。',
      en:
        'ALLIN is the community consensus coin for those who go all in. We chronicle the people who pushed every chip to the center of the table — their stories, their spirit, their words. No team promises. No roadmap magic. Only a circle of believers who acted on conviction.',
      zhTW:
        'ALLIN 是屬於梭哈者的社群共識幣。這裡收錄那些把全部押了上去的人——他們的故事、他們的精神、他們的語錄。沒有團隊承諾，沒有路線圖魔法，只有一群信仰「看懂之後就梭哈」的人，把籌碼推到了桌子中央。',
      ja:
        'ALLIN は、オールインする者たちのコミュニティ・コンセンサス・コインです。すべてのチップをテーブルの中央に押し出した人々の物語、精神、言葉を記録します。チームの約束も、ロードマップの魔法もありません。あるのは「見極めたら全部行け」を信じる者たちが、確信に基づいて動いた跡だけです。',
      ko:
        'ALLIN은 올인하는 사람들의 커뮤니티 합의 토큰입니다. 모든 칩을 테이블 중앙으로 밀어 넣은 사람들의 이야기, 정신, 어록을 기록합니다. 팀의 약속도, 로드맵의 마법도 없습니다. 오직 "꿰뚫어 봤다면 올인하라"를 믿는 사람들이 확신에 따라 행동한 흔적만 남아 있습니다.',
      vi:
        'ALLIN là token đồng thuận cộng đồng của những người đặt tất cả lên một thứ. Đây là nơi ghi lại câu chuyện, tinh thần và lời nói của những người đẩy mọi chip vào giữa bàn. Không có cam kết của đội ngũ. Không có phép thuật roadmap. Chỉ có một nhóm người tin vào "thấy rõ thì đặt tất cả" và họ đã hành động theo niềm tin đó.',
    },
    buy: {
      zh: '立即购买 →',
      en: 'Buy Now →',
      zhTW: '立即購買 →',
      ja: '今すぐ購入 →',
      ko: '지금 구매 →',
      vi: 'Mua ngay →',
    },
    readStories: {
      zh: '阅读梭哈故事',
      en: 'Read the stories',
      zhTW: '閱讀梭哈故事',
      ja: 'ストーリーを読む',
      ko: '스토리 읽기',
      vi: 'Đọc các câu chuyện',
    },
    thesisLabel: {
      zh: '共识宣言 · 第一条',
      en: 'Manifesto · §01',
      zhTW: '共識宣言 · 第一條',
      ja: '宣言 · §01',
      ko: '선언 · §01',
      vi: 'Tuyên ngôn · §01',
    },
    thesis: {
      zh:
        '"梭哈，不是因为你有多大胆，而是因为你看清了。看清之后，犹豫才是最大的风险。"',
      en:
        '"Going all in is not about courage. It is about clarity. After clarity, hesitation is the only real risk."',
      zhTW:
        '「梭哈，不是因為你有多大膽，而是因為你看清了。看清之後，猶豫才是最大的風險。」',
      ja:
        '「オールインは勇気の問題ではない。明晰さの問題だ。明晰さの後、ためらいだけが本当のリスクとなる。」',
      ko:
        '"올인은 용기의 문제가 아니다. 명료함의 문제다. 명료해진 뒤에는 망설임만이 진짜 리스크다."',
      vi:
        '"All In không phải là dũng khí. Đó là sự rõ ràng. Sau khi đã rõ ràng, do dự mới là rủi ro duy nhất."',
    },
    thesisCite: {
      zh: '— ALLIN 社区',
      en: '— The ALLIN community',
      zhTW: '— ALLIN 社群',
      ja: '— ALLIN コミュニティ',
      ko: '— ALLIN 커뮤니티',
      vi: '— Cộng đồng ALLIN',
    },
    contractLabel: {
      zh: '合约地址',
      en: 'Contract Address',
      zhTW: '合約地址',
      ja: 'コントラクトアドレス',
      ko: '컨트랙트 주소',
      vi: 'Địa chỉ hợp đồng',
    },
    network: {
      zh: 'BNB 链',
      en: 'BNB Chain',
      zhTW: 'BNB 鏈',
      ja: 'BNB チェーン',
      ko: 'BNB 체인',
      vi: 'BNB Chain',
    },
  },
  stats: {
    mcap: {
      zh: '市值', en: 'Market Cap',
      zhTW: '市值', ja: '時価総額', ko: '시가총액', vi: 'Vốn hóa',
    },
    mcapDeltaSuffix: {
      zh: '24 小时', en: '24h',
      zhTW: '24 小時', ja: '24時間', ko: '24시간', vi: '24h',
    },
    mcapDeltaWaiting: {
      zh: '加载中…', en: 'Loading…',
      zhTW: '載入中…', ja: '読み込み中…', ko: '불러오는 중…', vi: 'Đang tải…',
    },
    holders: {
      zh: '持有人数', en: 'Holders',
      zhTW: '持有人數', ja: 'ホルダー数', ko: '홀더 수', vi: 'Người nắm giữ',
    },
    holdersSub: {
      zh: '链上总数', en: 'On-chain total',
      zhTW: '鏈上總數', ja: 'オンチェーン総数', ko: '온체인 총수', vi: 'Tổng on-chain',
    },
    volume: {
      zh: '24h 交易量', en: '24h Volume',
      zhTW: '24h 交易量', ja: '24時間出来高', ko: '24시간 거래량', vi: 'KL 24h',
    },
    volumeSub: {
      zh: '过去 24 小时', en: 'Past 24 hours',
      zhTW: '過去 24 小時', ja: '過去24時間', ko: '지난 24시간', vi: '24 giờ qua',
    },
    liquidity: {
      zh: '池子 USDT', en: 'Pool USDT',
      zhTW: '池子 USDT', ja: 'プール USDT', ko: '풀 USDT', vi: 'Pool USDT',
    },
    liquiditySub: {
      zh: 'PancakeSwap V2 锁仓', en: 'Locked on PancakeSwap V2',
      zhTW: 'PancakeSwap V2 鎖倉',
      ja: 'PancakeSwap V2 にロック',
      ko: 'PancakeSwap V2 락업',
      vi: 'Khóa trên PancakeSwap V2',
    },
  },
  spark: {
    pair: { zh: 'ALLIN / USDT', en: 'ALLIN / USDT', zhTW: 'ALLIN / USDT', ja: 'ALLIN / USDT', ko: 'ALLIN / USDT', vi: 'ALLIN / USDT' },
    range: {
      zh: '24 小时趋势', en: '24h trend',
      zhTW: '24 小時走勢', ja: '24時間トレンド', ko: '24시간 추세', vi: 'Xu hướng 24h',
    },
    note: {
      zh: '示意走势 · 实时数据接入中',
      en: 'Indicative trend · Live feed coming soon',
      zhTW: '示意走勢 · 即時數據接入中',
      ja: '参考トレンド · ライブデータ接続中',
      ko: '참고 추세 · 실시간 데이터 연결 중',
      vi: 'Xu hướng tham khảo · Đang kết nối dữ liệu',
    },
  },
  manifesto: {
    homeLink: {
      zh: '阅读《梭哈宣言》→', en: 'Read the Manifesto →',
      zhTW: '閱讀《梭哈宣言》→',
      ja: '「オールイン宣言」を読む →',
      ko: '〈올인 선언〉 읽기 →',
      vi: 'Đọc Tuyên ngôn All In →',
    },
    back: {
      zh: '← 返回首页', en: '← Back to home',
      zhTW: '← 返回首頁', ja: '← ホームへ戻る', ko: '← 홈으로', vi: '← Về trang chủ',
    },
    eyebrow: {
      zh: 'ALLIN 社区 · 初版', en: 'ALLIN Community · v1',
      zhTW: 'ALLIN 社群 · 初版',
      ja: 'ALLIN コミュニティ · v1',
      ko: 'ALLIN 커뮤니티 · v1',
      vi: 'Cộng đồng ALLIN · v1',
    },
    title: {
      zh: '梭哈宣言', en: 'The All-In Manifesto',
      zhTW: '梭哈宣言', ja: 'オールイン宣言', ko: '올인 선언', vi: 'Tuyên ngôn All In',
    },
    subtitle: {
      zh: '一份给把全部押在一件事上的人的备忘录。',
      en: 'A note for those who put it all into one thing.',
      zhTW: '一份給把全部押在一件事上的人的備忘錄。',
      ja: '一つのことにすべてを賭けた人々への覚え書き。',
      ko: '한 가지에 모든 것을 건 사람들을 위한 메모.',
      vi: 'Một bản ghi chú cho những ai đã đặt tất cả vào một việc.',
    },
    edition: {
      zh: '初版 · 2026 春', en: 'v1 · Spring 2026',
      zhTW: '初版 · 2026 春',
      ja: '初版 · 2026年春',
      ko: '초판 · 2026 봄',
      vi: 'Bản v1 · Mùa xuân 2026',
    },
    tocTitle: {
      zh: '目录', en: 'Contents',
      zhTW: '目錄', ja: '目次', ko: '목차', vi: 'Mục lục',
    },
    pendingTag: {
      zh: '敬请期待', en: 'Coming soon',
      zhTW: '敬請期待', ja: '近日公開', ko: '곧 공개', vi: 'Sắp ra mắt',
    },
    enNotice: {
      // No longer rendered. Kept for backward-compat; null-fall-through safe.
      zh: null, en: null, zhTW: null, ja: null, ko: null, vi: null,
    },
    footerNote: {
      zh:
        '本宣言由 ALLIN 社区共同执笔。文字以 CC0 协议公开——任何人可以引用、翻译、再创作。',
      en:
        'This manifesto is written collectively by the ALLIN community. Released under CC0 — anyone may quote, translate, or remix.',
      zhTW:
        '本宣言由 ALLIN 社群共同執筆。文字以 CC0 協議公開——任何人可以引用、翻譯、再創作。',
      ja:
        'この宣言は ALLIN コミュニティが共同で執筆しました。CC0 で公開——誰でも引用・翻訳・リミックスできます。',
      ko:
        '이 선언은 ALLIN 커뮤니티가 공동 집필했습니다. CC0로 공개되며 누구나 인용·번역·재창작할 수 있습니다.',
      vi:
        'Tuyên ngôn này được Cộng đồng ALLIN đồng biên soạn. Phát hành theo CC0 — bất cứ ai cũng có thể trích dẫn, dịch và tái sáng tạo.',
    },
  },
  marquee: {
    zh: ['梭哈', '看懂就押', '押上全部', '不留余地', '看清了就出手', '把筹码推到桌子中央'],
    en: ['All In', 'Conviction', 'Push It All', 'No Hedging', 'See It · Bet It', 'Center of the Table'],
    zhTW: ['梭哈', '看懂就押', '押上全部', '不留餘地', '看清了就出手', '把籌碼推到桌子中央'],
    ja: ['オールイン', '確信', '全部押す', '逃げ道なし', '見えたら動く', 'テーブルの中央へ'],
    ko: ['올인', '확신', '전부 밀어라', '여지 없음', '보이면 행동', '테이블 중앙으로'],
    vi: ['All In', 'Niềm tin', 'Đẩy hết', 'Không hedging', 'Thấy thì đặt', 'Vào giữa bàn'],
  },
  sections: {
    ch1: { zh: '章节 · 一', en: 'Chapter · I', zhTW: '章節 · 一', ja: '第一章', ko: '제1장', vi: 'Chương · I' },
    ch2: { zh: '章节 · 二', en: 'Chapter · II', zhTW: '章節 · 二', ja: '第二章', ko: '제2장', vi: 'Chương · II' },
    ch3: { zh: '章节 · 三', en: 'Chapter · III', zhTW: '章節 · 三', ja: '第三章', ko: '제3장', vi: 'Chương · III' },
    ch4: { zh: '章节 · 四', en: 'Chapter · IV', zhTW: '章節 · 四', ja: '第四章', ko: '제4장', vi: 'Chương · IV' },
    spiritT1: { zh: '梭哈', en: 'The ', zhTW: '梭哈', ja: 'オールインの', ko: '올인 ', vi: 'Tinh thần ' },
    spiritT2: { zh: '精神。', en: 'Spirit.', zhTW: '精神。', ja: '精神。', ko: '정신.', vi: 'All In.' },
    spiritDesc: {
      zh:
        '我们不是在卖代币，我们在记录一种精神。把全部押上去的人，不是赌徒，是看清了的清醒者。这是 ALLIN 的三条社区原则。',
      en:
        'We are not selling a token. We are recording a spirit. Those who pushed everything in are not gamblers — they are people who saw clearly. These are the three principles of ALLIN.',
      zhTW:
        '我們不是在賣代幣，我們在記錄一種精神。把全部押上去的人，不是賭徒，是看清了的清醒者。這是 ALLIN 的三條社群原則。',
      ja:
        '私たちはトークンを売っているのではなく、ある種の精神を記録しています。すべてを賭けた人々はギャンブラーではなく、見極めた覚醒者です。これが ALLIN の三つのコミュニティ原則です。',
      ko:
        '우리는 토큰을 파는 것이 아니라 하나의 정신을 기록합니다. 모든 것을 건 이들은 도박꾼이 아니라 분명히 본 자들입니다. ALLIN의 세 가지 커뮤니티 원칙입니다.',
      vi:
        'Chúng tôi không bán token. Chúng tôi ghi lại một tinh thần. Những người đặt tất cả không phải con bạc — họ là những người đã thấy rõ. Đây là ba nguyên tắc của ALLIN.',
    },
    quotesT1: { zh: '大佬', en: 'The ', zhTW: '大佬', ja: '偉人の', ko: '거인의 ', vi: 'Những ' },
    quotesT2: { zh: '语录。', en: 'Quotes.', zhTW: '語錄。', ja: '名言。', ko: '어록.', vi: 'trích dẫn.' },
    quotesDesc: {
      zh:
        '那些把全部押上去的人，留下了一些话。它们在不同年份、不同行业里被说出，但讲的是同一件事。',
      en:
        'Those who bet it all left some words behind. Spoken in different years and different industries — but pointing at the same thing.',
      zhTW:
        '那些把全部押上去的人，留下了一些話。它們在不同年份、不同行業裡被說出，但講的是同一件事。',
      ja:
        'すべてを賭けた人々は、いくつかの言葉を残しました。違う年代、違う業界で語られましたが、指し示すものは同じです。',
      ko:
        '모든 것을 건 이들은 몇 마디를 남겼습니다. 서로 다른 시대, 서로 다른 업계에서 나왔지만 가리키는 것은 같습니다.',
      vi:
        'Những người đặt tất cả đã để lại vài câu nói. Nói ở những năm khác nhau, ngành khác nhau — nhưng chỉ đến cùng một điều.',
    },
    storiesT1: { zh: '梭哈', en: 'The ', zhTW: '梭哈', ja: 'オールインの', ko: '올인 ', vi: 'Câu chuyện ' },
    storiesT2: { zh: '故事。', en: 'Stories.', zhTW: '故事。', ja: '物語。', ko: '이야기.', vi: 'All In.' },
    storiesDesc: {
      zh:
        '这一节收录最经典的"梭哈时刻"。每一个故事都有一个具体的瞬间——他们站在悬崖边，把所有筹码推了过去。',
      en:
        'The most iconic all-in moments. Each story has one specific instant — the cliff edge where they pushed every chip across.',
      zhTW:
        '這一節收錄最經典的「梭哈時刻」。每一個故事都有一個具體的瞬間——他們站在懸崖邊，把所有籌碼推了過去。',
      ja:
        '最も象徴的なオールインの瞬間。それぞれの物語に一つの具体的な瞬間があります——崖の縁に立ち、全てのチップを押し出した瞬間です。',
      ko:
        '가장 상징적인 올인의 순간. 모든 이야기에 하나의 구체적인 순간이 있습니다 — 절벽 끝에서 모든 칩을 밀어 넣은 그 순간.',
      vi:
        'Những khoảnh khắc All In biểu tượng nhất. Mỗi câu chuyện có một thời điểm cụ thể — bờ vực mà họ đẩy hết chip qua.',
    },
    chartT1: { zh: '实时', en: 'Live ', zhTW: '即時', ja: 'リアルタイム', ko: '실시간 ', vi: 'Thị trường ' },
    chartT2: { zh: '行情。', en: 'Market.', zhTW: '行情。', ja: 'マーケット。', ko: '마켓.', vi: 'thời gian thực.' },
    chartDesc: {
      zh: '行情数据来自 DexScreener。点击右上角可在新窗口打开完整交易视图。',
      en: 'Market data from DexScreener. Open the full trading view in a new tab via the top-right link.',
      zhTW: '行情數據來自 DexScreener。點擊右上角可在新視窗開啟完整交易頁。',
      ja: 'マーケットデータは DexScreener から。右上のリンクから完全なトレーディングビューを新しいタブで開けます。',
      ko: '마켓 데이터는 DexScreener에서 제공됩니다. 우측 상단 링크로 전체 거래 뷰를 새 탭에서 열 수 있습니다.',
      vi: 'Dữ liệu thị trường từ DexScreener. Mở giao diện giao dịch đầy đủ qua liên kết góc trên bên phải.',
    },
  },
  chart: {
    openDex: {
      zh: '在 DexScreener 打开 ↗', en: 'Open on DexScreener ↗',
      zhTW: '在 DexScreener 開啟 ↗',
      ja: 'DexScreener で開く ↗',
      ko: 'DexScreener에서 열기 ↗',
      vi: 'Mở trên DexScreener ↗',
    },
    swap: {
      zh: 'PancakeSwap 交易 →', en: 'Trade on PancakeSwap →',
      zhTW: '在 PancakeSwap 交易 →',
      ja: 'PancakeSwap で取引 →',
      ko: 'PancakeSwap에서 거래 →',
      vi: 'Giao dịch trên PancakeSwap →',
    },
  },
  token: {
    copy: {
      zh: '复制地址', en: 'Copy address',
      zhTW: '複製地址', ja: 'アドレスをコピー', ko: '주소 복사', vi: 'Sao chép địa chỉ',
    },
    copied: {
      zh: '✓ 已复制', en: '✓ Copied',
      zhTW: '✓ 已複製', ja: '✓ コピー済み', ko: '✓ 복사됨', vi: '✓ Đã sao chép',
    },
  },
  cta: {
    t1: { zh: '你，', en: 'Are you ', zhTW: '你，', ja: 'あなたは、', ko: '당신은, ', vi: 'Bạn, ' },
    t2: { zh: '梭吗？', en: 'in?', zhTW: '梭嗎？', ja: '行きますか？', ko: '올인합니까?', vi: 'đặt tất cả?' },
    desc: {
      zh:
        '如果你正站在那个瞬间——研究做完了、风险想清了，只差把筹码推过去——这里就是你的桌子。',
      en:
        "If you're at that moment — research done, risks clear, only the push left to make — this is your table.",
      zhTW:
        '如果你正站在那個瞬間——研究做完了、風險想清了，只差把籌碼推過去——這裡就是你的桌子。',
      ja:
        'もしあなたがその瞬間に立っているなら——調査は終わり、リスクは見え、あとはチップを押し出すだけ——ここがあなたのテーブルです。',
      ko:
        '그 순간에 서 있다면 — 조사는 끝났고, 리스크는 분명하고, 칩을 밀어 넣는 일만 남았다면 — 여기가 당신의 테이블입니다.',
      vi:
        'Nếu bạn đang ở khoảnh khắc đó — nghiên cứu xong, rủi ro đã rõ, chỉ còn việc đẩy chip vào — thì đây là bàn của bạn.',
    },
    buy: {
      zh: '立即购买 →', en: 'Buy Now →',
      zhTW: '立即購買 →', ja: '今すぐ購入 →', ko: '지금 구매 →', vi: 'Mua ngay →',
    },
    community: {
      zh: '加入社区', en: 'Join Community',
      zhTW: '加入社群', ja: 'コミュニティに参加', ko: '커뮤니티 참여', vi: 'Tham gia cộng đồng',
    },
  },
  footer: {
    tagline: {
      zh: '梭哈者的社区共识币。由信仰"看懂就梭"的人共同维护。',
      en: 'The community consensus coin for those who go all in. Maintained by believers in clarity.',
      zhTW: '梭哈者的社群共識幣。由信仰「看懂就梭」的人共同維護。',
      ja: 'オールインする者たちのコミュニティ・コンセンサス・コイン。「見極めたら全部行け」を信じる者たちが共同で運営する。',
      ko: '올인하는 사람들의 커뮤니티 합의 토큰. "꿰뚫어 봤다면 올인하라"를 믿는 사람들이 함께 운영합니다.',
      vi: 'Token đồng thuận cộng đồng cho những người đặt tất cả. Được duy trì bởi những người tin vào "thấy rõ thì đặt tất cả."',
    },
    protocol: {
      zh: '协议', en: 'Protocol',
      zhTW: '協議', ja: 'プロトコル', ko: '프로토콜', vi: 'Giao thức',
    },
    community: {
      zh: '社区', en: 'Community',
      zhTW: '社群', ja: 'コミュニティ', ko: '커뮤니티', vi: 'Cộng đồng',
    },
    resources: {
      zh: '资源', en: 'Resources',
      zhTW: '資源', ja: 'リソース', ko: '리소스', vi: 'Tài nguyên',
    },
    chartLink: {
      zh: '行情', en: 'Chart',
      zhTW: '行情', ja: 'チャート', ko: '차트', vi: 'Biểu đồ',
    },
    spiritLink: {
      zh: '梭哈精神', en: 'Spirit',
      zhTW: '梭哈精神', ja: '精神', ko: '정신', vi: 'Tinh thần',
    },
    twitter: { zh: '推特', en: 'Twitter', zhTW: '推特', ja: 'Twitter', ko: '트위터', vi: 'Twitter' },
    telegram: { zh: '电报群', en: 'Telegram', zhTW: '電報群', ja: 'Telegram', ko: '텔레그램', vi: 'Telegram' },
    discord: { zh: 'Discord', en: 'Discord', zhTW: 'Discord', ja: 'Discord', ko: 'Discord', vi: 'Discord' },
    storiesLink: {
      zh: '梭哈故事', en: 'Stories',
      zhTW: '梭哈故事', ja: 'ストーリー', ko: '스토리', vi: 'Câu chuyện',
    },
    quotesLink: {
      zh: '大佬语录', en: 'Quotes',
      zhTW: '大佬語錄', ja: '名言', ko: '어록', vi: 'Trích dẫn',
    },
    contractLink: {
      zh: '合约地址', en: 'Contract',
      zhTW: '合約地址', ja: 'コントラクト', ko: '컨트랙트', vi: 'Hợp đồng',
    },
    copyright: {
      zh: '© 2026 ALLIN 社区', en: '© 2026 ALLIN Community',
      zhTW: '© 2026 ALLIN 社群',
      ja: '© 2026 ALLIN コミュニティ',
      ko: '© 2026 ALLIN 커뮤니티',
      vi: '© 2026 Cộng đồng ALLIN',
    },
    disclaimer: {
      zh: '由信仰驱动 · 内容仅供参考，非投资建议',
      en: 'Built on conviction · Not financial advice',
      zhTW: '由信仰驅動 · 內容僅供參考，非投資建議',
      ja: '信念に基づいて構築 · 投資助言ではありません',
      ko: '신념으로 만들었습니다 · 투자 자문이 아닙니다',
      vi: 'Xây trên niềm tin · Không phải lời khuyên đầu tư',
    },
  },
};

export const SPIRIT = [
  {
    n: 'I',
    title: {
      zh: '看懂了，就梭哈', en: 'See it, then all in',
      zhTW: '看懂了，就梭哈',
      ja: '見極めたら、オールイン',
      ko: '꿰뚫어 봤다면, 올인하라',
      vi: 'Thấy rõ rồi, đặt tất cả',
    },
    desc: {
      zh: '梭哈不是赌运气，是把研究做透之后的一次性下注。看不懂的东西不碰，看懂了不要只下小注。',
      en: "All in is not gambling on luck — it's a one-shot bet after the research is done. Don't touch what you don't understand. When you do, don't bet small.",
      zhTW: '梭哈不是賭運氣，是把研究做透之後的一次性下注。看不懂的東西不碰，看懂了不要只下小注。',
      ja: 'オールインは運の賭けではなく、研究を尽くした後の一点突破です。理解できないものには触れない。理解したなら小さく賭けない。',
      ko: '올인은 운에 거는 게 아니라 연구를 끝낸 뒤의 일회성 베팅입니다. 이해 못 하는 것엔 손대지 말고, 이해했다면 작게 걸지 마세요.',
      vi: 'All In không phải đặt cược vào may rủi — đó là cú đặt một lần sau khi đã nghiên cứu kỹ. Đừng động đến cái bạn không hiểu. Khi đã hiểu, đừng đặt nhỏ.',
    },
  },
  {
    n: 'II',
    title: {
      zh: '愿赌服输', en: 'Accept the outcome',
      zhTW: '願賭服輸',
      ja: '賭けの結果を受け入れる',
      ko: '결과를 받아들여라',
      vi: 'Chấp nhận kết quả',
    },
    desc: {
      zh: '社区共识币不承诺收益，只承诺真实。每一个进来的人，都是带着自己的判断和勇气来的。',
      en: 'A community consensus coin promises nothing but honesty. Everyone who joins brings their own judgment and their own courage.',
      zhTW: '社群共識幣不承諾收益，只承諾真實。每一個進來的人，都是帶著自己的判斷和勇氣來的。',
      ja: 'コミュニティ・コンセンサス・コインはリターンを約束せず、真実だけを約束します。ここに来る人は皆、自分の判断と勇気を携えてきます。',
      ko: '커뮤니티 합의 토큰은 수익을 약속하지 않고 오직 진실만 약속합니다. 이곳에 들어오는 모두가 자신의 판단과 용기를 가지고 옵니다.',
      vi: 'Token đồng thuận cộng đồng không hứa lợi nhuận, chỉ hứa sự thật. Mọi người vào đây đều mang theo phán đoán và dũng khí của riêng mình.',
    },
  },
  {
    n: 'III',
    title: {
      zh: '只做长期主义者的同路人', en: 'Travel only with long-termists',
      zhTW: '只做長期主義者的同路人',
      ja: '長期主義者とだけ歩む',
      ko: '장기주의자와만 동행한다',
      vi: 'Chỉ đồng hành với người dài hạn',
    },
    desc: {
      zh: '收录每一个把全部押在一件事上的人。他们的故事和精神，是这枚代币唯一的底层价值。',
      en: 'We chronicle every person who put everything into one thing. Their stories and their spirit are the only fundamentals of this token.',
      zhTW: '收錄每一個把全部押在一件事上的人。他們的故事和精神，是這枚代幣唯一的底層價值。',
      ja: '一つのことに全部を賭けたすべての人を記録します。彼らの物語と精神こそが、このトークンの唯一のファンダメンタルズです。',
      ko: '한 가지에 모든 것을 건 모든 이들을 기록합니다. 그들의 이야기와 정신이 이 토큰의 유일한 기초 가치입니다.',
      vi: 'Ghi lại mọi người đã đặt tất cả vào một việc. Câu chuyện và tinh thần của họ là giá trị nền tảng duy nhất của token này.',
    },
  },
];

export const QUOTES = [
  {
    size: 'feature',
    text: { zh: '梭哈！', en: 'All In!', zhTW: '梭哈！', ja: 'オールイン！', ko: '올인!', vi: 'All In!' },
    author: { zh: '孙宇晨', en: 'Justin Sun', zhTW: '孫宇晨', ja: 'ジャスティン・サン', ko: '저스틴 선', vi: 'Justin Sun' },
    role: {
      zh: '波场创始人 · 2017', en: 'TRON founder · 2017',
      zhTW: '波場創辦人 · 2017',
      ja: 'TRON 創設者 · 2017',
      ko: 'TRON 창립자 · 2017',
      vi: 'Người sáng lập TRON · 2017',
    },
  },
  {
    size: 'sm',
    text: {
      zh: '站在风口上，猪都能飞起来。',
      en: 'Stand at the right gust — even pigs can fly.',
      zhTW: '站在風口上，豬都能飛起來。',
      ja: '風の向きが合えば、豚でも飛べる。',
      ko: '바람이 맞으면 돼지도 난다.',
      vi: 'Đứng đúng gió, lợn cũng bay.',
    },
    author: { zh: '雷军', en: 'Lei Jun', zhTW: '雷軍', ja: '雷軍', ko: '레이쥔', vi: 'Lei Jun' },
    role: {
      zh: '小米创始人 · 2010', en: 'Xiaomi founder · 2010',
      zhTW: '小米創辦人 · 2010',
      ja: 'Xiaomi 創設者 · 2010',
      ko: '샤오미 창립자 · 2010',
      vi: 'Người sáng lập Xiaomi · 2010',
    },
  },
  {
    size: 'sm',
    text: {
      zh: '求知若饥，虚心若愚。', en: 'Stay hungry. Stay foolish.',
      zhTW: '求知若飢，虛心若愚。',
      ja: 'ハングリーであれ、愚かであれ。',
      ko: '항상 갈망하라. 우직하게 나아가라.',
      vi: 'Hãy luôn khao khát. Hãy luôn dại khờ.',
    },
    author: {
      zh: '史蒂夫 · 乔布斯', en: 'Steve Jobs',
      zhTW: '史蒂夫 · 賈伯斯',
      ja: 'スティーブ・ジョブズ',
      ko: '스티브 잡스',
      vi: 'Steve Jobs',
    },
    role: {
      zh: '苹果 · 斯坦福 2005', en: 'Apple · Stanford 2005',
      zhTW: '蘋果 · 史丹佛 2005',
      ja: 'Apple · スタンフォード 2005',
      ko: 'Apple · 스탠퍼드 2005',
      vi: 'Apple · Stanford 2005',
    },
  },
  {
    size: 'sm',
    text: {
      zh: '干就完了。', en: 'BUIDL.',
      zhTW: '幹就完了。',
      ja: '黙ってビルドしろ。',
      ko: '그냥 빌드해라.',
      vi: 'Cứ xây thôi.',
    },
    author: { zh: '赵长鹏', en: 'CZ', zhTW: '趙長鵬', ja: 'CZ', ko: 'CZ', vi: 'CZ' },
    role: {
      zh: '币安创始人 · 2018', en: 'Binance founder · 2018',
      zhTW: '幣安創辦人 · 2018',
      ja: 'Binance 創設者 · 2018',
      ko: '바이낸스 창립자 · 2018',
      vi: 'Người sáng lập Binance · 2018',
    },
  },
  {
    size: 'md',
    text: {
      zh: '如果一件事足够重要，即便胜算不在你这边，也要去做。',
      en: 'When something is important enough, you do it even if the odds are not in your favor.',
      zhTW: '如果一件事足夠重要，即便勝算不在你這邊，也要去做。',
      ja: '十分に重要なことなら、勝算がなくてもやれ。',
      ko: '충분히 중요한 일이라면, 승산이 없어도 하라.',
      vi: 'Nếu một việc đủ quan trọng, hãy làm dù tỉ lệ thắng không nghiêng về bạn.',
    },
    author: {
      zh: '埃隆 · 马斯克', en: 'Elon Musk',
      zhTW: '伊隆 · 馬斯克',
      ja: 'イーロン・マスク',
      ko: '일론 머스크',
      vi: 'Elon Musk',
    },
    role: {
      zh: '特斯拉 & SpaceX · 2008', en: 'Tesla & SpaceX · 2008',
      zhTW: '特斯拉 & SpaceX · 2008',
      ja: 'Tesla & SpaceX · 2008',
      ko: 'Tesla & SpaceX · 2008',
      vi: 'Tesla & SpaceX · 2008',
    },
  },
  {
    size: 'md',
    text: {
      zh: '九败一胜。胜利属于把所有筹码推到桌子中央的人。',
      en: 'Nine losses, one win. The pot goes to whoever pushes every chip to the center.',
      zhTW: '九敗一勝。勝利屬於把所有籌碼推到桌子中央的人。',
      ja: '九敗一勝。勝利はすべてのチップをテーブル中央へ押し出した者のものだ。',
      ko: '9패 1승. 승리는 모든 칩을 테이블 중앙으로 민 자의 것이다.',
      vi: 'Chín thua một thắng. Chiến thắng thuộc về kẻ đẩy mọi chip vào giữa bàn.',
    },
    author: { zh: '王兴', en: 'Wang Xing', zhTW: '王興', ja: '王興', ko: '왕싱', vi: 'Wang Xing' },
    role: {
      zh: '美团创始人', en: 'Meituan founder',
      zhTW: '美團創辦人',
      ja: 'Meituan 創設者',
      ko: '메이퇀 창립자',
      vi: 'Người sáng lập Meituan',
    },
  },
  {
    size: 'sm',
    text: {
      zh: '保持常识，远离喧嚣。本分。',
      en: 'Keep common sense. Stay far from the noise.',
      zhTW: '保持常識，遠離喧囂。本分。',
      ja: '常識を保ち、喧騒から遠ざかる。本分。',
      ko: '상식을 유지하고, 소란에서 멀어져라. 본분.',
      vi: 'Giữ thường thức. Tránh xa ồn ào. Bổn phận.',
    },
    author: {
      zh: '黄峥', en: 'Colin Huang',
      zhTW: '黃崢', ja: 'コリン・ホアン', ko: '콜린 황', vi: 'Colin Huang',
    },
    role: {
      zh: '拼多多创始人', en: 'Pinduoduo founder',
      zhTW: '拼多多創辦人',
      ja: 'Pinduoduo 創設者',
      ko: '핀듀오듀오 창립자',
      vi: 'Người sáng lập Pinduoduo',
    },
  },
  {
    size: 'sm',
    text: {
      zh: '延迟满足感。', en: 'Delayed gratification.',
      zhTW: '延遲滿足感。',
      ja: '遅延報酬。',
      ko: '만족 유예.',
      vi: 'Trì hoãn thỏa mãn.',
    },
    author: {
      zh: '张一鸣', en: 'Yiming Zhang',
      zhTW: '張一鳴', ja: '張一鳴', ko: '장이밍', vi: 'Zhang Yiming',
    },
    role: {
      zh: '字节跳动创始人', en: 'ByteDance founder',
      zhTW: '字節跳動創辦人',
      ja: 'ByteDance 創設者',
      ko: '바이트댄스 창립자',
      vi: 'Người sáng lập ByteDance',
    },
  },
  {
    size: 'sm',
    text: {
      zh: '永远是创业第一天。', en: "It's always Day 1.",
      zhTW: '永遠是創業第一天。',
      ja: 'いつも Day 1 だ。',
      ko: '언제나 Day 1.',
      vi: 'Luôn luôn là Day 1.',
    },
    author: {
      zh: '杰夫 · 贝索斯', en: 'Jeff Bezos',
      zhTW: '傑夫 · 貝佐斯',
      ja: 'ジェフ・ベゾス',
      ko: '제프 베이조스',
      vi: 'Jeff Bezos',
    },
    role: {
      zh: '亚马逊创始人', en: 'Amazon founder',
      zhTW: '亞馬遜創辦人',
      ja: 'Amazon 創設者',
      ko: '아마존 창립자',
      vi: 'Người sáng lập Amazon',
    },
  },
  {
    size: 'feature',
    text: {
      zh: '梭哈，不是赌博。是看懂之后，把全部筹码推过去。',
      en: "All in is not a bet. It's pushing every chip across — after you understand.",
      zhTW: '梭哈，不是賭博。是看懂之後，把全部籌碼推過去。',
      ja: 'オールインはギャンブルではない。見極めたうえで、全てのチップを押し出す行為だ。',
      ko: '올인은 도박이 아니다. 꿰뚫어 본 뒤, 모든 칩을 밀어 넣는 행위다.',
      vi: 'All In không phải đánh bạc. Là sau khi đã thấy rõ, đẩy hết chip vào.',
    },
    author: {
      zh: 'ALLIN 共识宣言', en: 'ALLIN Manifesto',
      zhTW: 'ALLIN 共識宣言',
      ja: 'ALLIN 宣言',
      ko: 'ALLIN 선언',
      vi: 'Tuyên ngôn ALLIN',
    },
    role: {
      zh: '社区，2026', en: 'Community, 2026',
      zhTW: '社群，2026',
      ja: 'コミュニティ、2026',
      ko: '커뮤니티, 2026',
      vi: 'Cộng đồng, 2026',
    },
  },
];

export const STORIES = [
  {
    year: '2008',
    tag: {
      zh: '航天 · 电动', en: 'SPACE · EV',
      zhTW: '航天 · 電動',
      ja: '宇宙 · EV',
      ko: '스페이스 · EV',
      vi: 'VŨ TRỤ · EV',
    },
    title: {
      zh: '马斯克的最后一颗火箭', en: "Musk's Last Rocket",
      zhTW: '馬斯克的最後一顆火箭',
      ja: 'マスクの最後のロケット',
      ko: '머스크의 마지막 로켓',
      vi: 'Tên lửa cuối cùng của Musk',
    },
    body: {
      zh:
        '金融危机来袭，PayPal 卖股的钱已烧完。SpaceX 三次发射全部失败，特斯拉濒临破产。马斯克把最后 3000 万美元梭哈到第四次发射——成功。同时把婚戒抵押贷款给特斯拉续命。从那之后，"全部押上"成为他唯一的选项。',
      en:
        'The crisis hit. The PayPal cash had burned. SpaceX had failed three launches in a row. Tesla was on the brink. Musk pushed his last $30M into a fourth launch — and it worked. He pawned his wedding ring to keep Tesla alive. From that day on, "all in" was his only option.',
      zhTW:
        '金融危機來襲，PayPal 賣股的錢已燒完。SpaceX 三次發射全部失敗，特斯拉瀕臨破產。馬斯克把最後 3000 萬美元梭哈到第四次發射——成功。同時把婚戒抵押貸款給特斯拉續命。從那之後，「全部押上」成為他唯一的選項。',
      ja:
        '金融危機が直撃し、PayPal 売却の資金は燃え尽きていた。SpaceX は三度の打ち上げに連敗、Tesla は破産寸前。マスクは最後の3000万ドルを第4回打ち上げにオールインし——成功した。同時に結婚指輪を担保に Tesla を延命させた。あの日以降、「全部行く」が彼の唯一の選択肢となった。',
      ko:
        '금융 위기가 닥쳤다. PayPal 매각 자금은 다 타버렸다. SpaceX는 세 번 연속 발사에 실패했고, Tesla는 파산 직전이었다. 머스크는 마지막 3,000만 달러를 4차 발사에 올인했고 — 성공했다. 동시에 결혼 반지를 담보로 잡아 Tesla를 연명시켰다. 그날 이후 "전부 걸기"가 그의 유일한 선택지였다.',
      vi:
        'Khủng hoảng ập đến. Tiền bán PayPal đã đốt sạch. SpaceX thất bại liên tiếp ba lần phóng. Tesla bên bờ vực phá sản. Musk đẩy 30 triệu USD cuối cùng vào lần phóng thứ tư — và thành công. Đồng thời cầm cố nhẫn cưới để cứu Tesla. Từ ngày đó, "đặt tất cả" là lựa chọn duy nhất của ông.',
    },
    line: {
      zh: '梭哈点 · 第四次发射成功', en: 'All-In · 4th launch success',
      zhTW: '梭哈點 · 第四次發射成功',
      ja: 'オールインの瞬間 · 4回目の打ち上げ成功',
      ko: '올인 순간 · 4차 발사 성공',
      vi: 'Khoảnh khắc All In · Phóng lần 4 thành công',
    },
    out: {
      zh: '万亿美元市值', en: '$1T+ market cap',
      zhTW: '兆美元市值',
      ja: '1兆ドル超の時価総額',
      ko: '1조 달러+ 시총',
      vi: 'Vốn hóa $1T+',
    },
    image: 'musk.jpg',
    initial: 'EM',
    surname: { zh: '马斯克', en: 'Musk', zhTW: '馬斯克', ja: 'マスク', ko: '머스크', vi: 'Musk' },
  },
  {
    year: '2010',
    tag: {
      zh: '智能手机', en: 'SMARTPHONE',
      zhTW: '智慧手機', ja: 'スマートフォン', ko: '스마트폰', vi: 'SMARTPHONE',
    },
    title: {
      zh: '雷军 40 岁的二次创业', en: 'Lei Jun, 40, Bets Again',
      zhTW: '雷軍 40 歲的二次創業',
      ja: '40歳の雷軍、再び勝負に出る',
      ko: '40세 레이쥔의 두 번째 창업',
      vi: 'Lei Jun, 40 tuổi, đặt cược lần hai',
    },
    body: {
      zh:
        '已经财富自由的雷军，在 40 岁的时候梭哈做小米。"如果不创业，40 岁之后我都不知道怎么向自己交代。" 第一天他喝了一碗小米粥，然后开始改变中国手机行业。',
      en:
        'Already financially free at 40, Lei Jun went all in on Xiaomi. "If I don\'t start a company, I won\'t know how to face myself after 40." On day one he drank a bowl of millet porridge — then started reshaping China\'s smartphone industry.',
      zhTW:
        '已經財富自由的雷軍，在 40 歲的時候梭哈做小米。「如果不創業，40 歲之後我都不知道怎麼向自己交代。」 第一天他喝了一碗小米粥，然後開始改變中國手機行業。',
      ja:
        'すでに経済的自由を手にしていた40歳の雷軍は、Xiaomi に全部を賭けた。「もし起業しなければ、40 歳以降の自分にどう向き合えばいいか分からない。」初日に小米（粟）粥を一杯飲み、そこから中国の携帯電話産業を塗り替え始めた。',
      ko:
        '이미 경제적 자유를 이룬 40세의 레이쥔은 샤오미에 올인했다. "창업하지 않으면 40세 이후 나 자신을 어떻게 마주할지 모르겠다." 첫날 그는 좁쌀죽 한 그릇을 마시고, 중국 스마트폰 산업을 다시 그리기 시작했다.',
      vi:
        'Đã tự do tài chính ở tuổi 40, Lei Jun đặt tất cả vào Xiaomi. "Nếu không khởi nghiệp, tôi không biết phải đối diện với chính mình sau tuổi 40 ra sao." Ngày đầu tiên, ông uống một bát cháo kê — rồi bắt đầu định hình lại ngành smartphone Trung Quốc.',
    },
    line: {
      zh: '梭哈点 · 一碗小米粥', en: 'All-In · A bowl of porridge',
      zhTW: '梭哈點 · 一碗小米粥',
      ja: 'オールインの瞬間 · 一杯の粟粥',
      ko: '올인 순간 · 좁쌀죽 한 그릇',
      vi: 'Khoảnh khắc All In · Một bát cháo kê',
    },
    out: {
      zh: '千亿美元市值', en: '$100B+ market cap',
      zhTW: '千億美元市值',
      ja: '1,000億ドル超の時価総額',
      ko: '1,000억 달러+ 시총',
      vi: 'Vốn hóa $100B+',
    },
    image: 'leijun.jpg',
    initial: 'LJ',
    surname: { zh: '雷军', en: 'Lei Jun', zhTW: '雷軍', ja: '雷軍', ko: '레이쥔', vi: 'Lei Jun' },
  },
  {
    year: '2012',
    tag: {
      zh: '本地服务', en: 'LOCAL SERVICES',
      zhTW: '本地服務',
      ja: 'ローカルサービス',
      ko: '로컬 서비스',
      vi: 'DỊCH VỤ NỘI ĐỊA',
    },
    title: {
      zh: '王兴的九败一胜', en: 'Nine Losses, One Win',
      zhTW: '王興的九敗一勝',
      ja: '王興の九敗一勝',
      ko: '왕싱의 9패 1승',
      vi: 'Chín thua, một thắng — Wang Xing',
    },
    body: {
      zh:
        '校内、饭否、海内——九次创业九次失败。第十次，团购千团大战，美团活下来了。王兴说："如果你拒绝失败，你也就拒绝了成功。" 把全部押上去的人，输不起，但也只有他们赢得起。',
      en:
        'Xiaonei, Fanfou, Hainei — nine startups, nine failures. The tenth was Meituan, the only survivor of the 1,000-group-buy war. "If you refuse failure, you refuse success." The ones who push everything in cannot afford to lose — but they\'re the only ones who can afford to win.',
      zhTW:
        '校內、飯否、海內——九次創業九次失敗。第十次，團購千團大戰，美團活下來了。王興說：「如果你拒絕失敗，你也就拒絕了成功。」 把全部押上去的人，輸不起，但也只有他們贏得起。',
      ja:
        '校内、Fanfou、Hainei——九度の起業、九度の失敗。十度目の挑戦で、千の共同購入サイトが争った戦争の唯一の生存者となったのが Meituan だった。王興は言う：「失敗を拒めば、成功も拒むことになる。」全部を賭ける者は負ければ取り返しがつかない——だが、勝てるのもこの者たちだけだ。',
      ko:
        '시아오네이, 판포우, 하이네이 — 아홉 번의 창업, 아홉 번의 실패. 열 번째 도전에서 1,000개 공동구매 사이트가 다툰 전쟁의 유일한 생존자가 메이퇀이었다. 왕싱은 말한다: "실패를 거부하면 성공도 거부하는 것이다." 모든 것을 거는 자는 질 여유가 없다 — 그러나 이길 수 있는 것도 이들뿐이다.',
      vi:
        'Xiaonei, Fanfou, Hainei — chín lần khởi nghiệp, chín lần thất bại. Lần thứ mười, Meituan là người duy nhất sống sót trong cuộc chiến của một ngàn trang group-buy. Wang Xing nói: "Nếu từ chối thất bại, bạn cũng từ chối thành công." Người đặt tất cả không thể thua — nhưng cũng chỉ họ mới có thể thắng.',
    },
    line: {
      zh: '梭哈点 · 千团大战末班车', en: 'All-In · Last train of the war',
      zhTW: '梭哈點 · 千團大戰末班車',
      ja: 'オールインの瞬間 · 千共同購入戦争の最終便',
      ko: '올인 순간 · 천 그룹 전쟁의 막차',
      vi: 'Khoảnh khắc All In · Chuyến cuối cuộc chiến group-buy',
    },
    out: {
      zh: '两千亿美元市值', en: '$200B+ market cap',
      zhTW: '兩千億美元市值',
      ja: '2,000億ドル超の時価総額',
      ko: '2,000억 달러+ 시총',
      vi: 'Vốn hóa $200B+',
    },
    image: 'wangxing.jpg',
    initial: 'WX',
    surname: { zh: '王兴', en: 'Wang Xing', zhTW: '王興', ja: '王興', ko: '왕싱', vi: 'Wang Xing' },
  },
  {
    year: '2016',
    tag: {
      zh: '内容算法', en: 'AI · CONTENT',
      zhTW: '內容演算法', ja: 'AI · コンテンツ', ko: 'AI · 콘텐츠', vi: 'AI · NỘI DUNG',
    },
    title: {
      zh: '张一鸣的算法信仰', en: 'Yiming, the Algorithm Believer',
      zhTW: '張一鳴的演算法信仰',
      ja: '張一鳴のアルゴリズム信仰',
      ko: '장이밍의 알고리즘 신앙',
      vi: 'Đức tin thuật toán của Yiming',
    },
    body: {
      zh:
        '所有人都做编辑推荐，他赌算法。所有人在中国卷，他出海赌抖音。每一次大赌都是行业逆向。"延迟满足感"不是慢，是把短期的诱惑全部砍掉，把所有筹码留给最大那一注。',
      en:
        'Everyone curated by editors. He bet on algorithms. Everyone fought inside China. He bet on TikTok overseas. Every big move was contrarian. "Delayed gratification" is not slowness — it\'s cutting every short-term temptation, saving every chip for the biggest bet.',
      zhTW:
        '所有人都做編輯推薦，他賭演算法。所有人在中國捲，他出海賭抖音。每一次大賭都是行業逆向。「延遲滿足感」不是慢，是把短期的誘惑全部砍掉，把所有籌碼留給最大那一注。',
      ja:
        '誰もが編集者推薦を採用するなか、彼はアルゴリズムに賭けた。皆が中国で消耗するなか、彼は海外に出て TikTok に賭けた。大勝負はすべて業界の逆張りだった。「遅延報酬」とは遅さではなく、短期の誘惑をすべて切り落として、最大の一発に全チップを残しておくことだ。',
      ko:
        '모두가 편집자 추천을 할 때, 그는 알고리즘에 걸었다. 모두가 중국 안에서 소모되고 있을 때, 그는 해외로 나가 틱톡에 걸었다. 큰 베팅은 매번 업계 역행이었다. "만족 유예"는 느림이 아니다 — 단기 유혹을 모두 잘라내고, 가장 큰 한 방을 위해 모든 칩을 남겨두는 것이다.',
      vi:
        'Tất cả đều biên tập đề xuất. Ông cược vào thuật toán. Tất cả đua tranh ở Trung Quốc. Ông ra biển với TikTok. Mỗi cú lớn đều ngược dòng ngành. "Trì hoãn thỏa mãn" không phải là chậm — đó là cắt mọi cám dỗ ngắn hạn, để dành mọi chip cho cú lớn nhất.',
    },
    line: {
      zh: '梭哈点 · 抖音出海', en: 'All-In · TikTok goes global',
      zhTW: '梭哈點 · 抖音出海',
      ja: 'オールインの瞬間 · TikTok 海外進出',
      ko: '올인 순간 · 틱톡 해외 진출',
      vi: 'Khoảnh khắc All In · TikTok ra biển lớn',
    },
    out: {
      zh: '全球第一短视频', en: '#1 short video globally',
      zhTW: '全球第一短影音',
      ja: '世界一のショート動画',
      ko: '글로벌 1위 숏폼',
      vi: 'Video ngắn số 1 toàn cầu',
    },
    image: 'zhangyiming.jpg',
    initial: 'ZY',
    surname: {
      zh: '张一鸣', en: 'Yiming Zhang',
      zhTW: '張一鳴', ja: '張一鳴', ko: '장이밍', vi: 'Zhang Yiming',
    },
  },
  {
    year: '2017',
    tag: {
      zh: '区块链', en: 'BLOCKCHAIN',
      zhTW: '區塊鏈', ja: 'ブロックチェーン', ko: '블록체인', vi: 'BLOCKCHAIN',
    },
    title: {
      zh: '孙宇晨的梭哈时刻', en: 'Justin Sun, All In on Camera',
      zhTW: '孫宇晨的梭哈時刻',
      ja: 'ジャスティン・サン、カメラの前のオールイン',
      ko: '카메라 앞에서 올인한 저스틴 선',
      vi: 'Justin Sun, All In trước ống kính',
    },
    body: {
      zh:
        '波场上线那一天，孙宇晨在镜头前把全部身家梭哈。从币圈"营销之王"到 TRX 跻身全球前十公链，他用"梭哈"这两个字注册了一个时代。后来这两个字成了所有梭哈者的接头暗号。',
      en:
        'The day TRON went live, Justin Sun pushed every chip in on camera. From "marketing king" of crypto to a top-10 public chain, he stamped an era with two words: All In. Those two words became the password of an entire generation of believers.',
      zhTW:
        '波場上線那一天，孫宇晨在鏡頭前把全部身家梭哈。從幣圈「行銷之王」到 TRX 躋身全球前十公鏈，他用「梭哈」這兩個字註冊了一個時代。後來這兩個字成了所有梭哈者的接頭暗號。',
      ja:
        'TRON が稼働を開始した日、ジャスティン・サンはカメラの前で全資産をオールインした。仮想通貨界の「マーケティング王」から世界トップ10のパブリックチェーンへ。彼は「オールイン」という二語で時代に印を刻んだ。やがてこの二語は信奉者の合言葉となった。',
      ko:
        'TRON이 가동을 시작한 날, 저스틴 선은 카메라 앞에서 전 재산을 올인했다. 크립토의 "마케팅 왕"에서 글로벌 톱10 퍼블릭 체인으로. 그는 "올인"이라는 두 단어로 한 시대에 도장을 찍었다. 이후 이 두 단어는 신봉자들의 암호가 되었다.',
      vi:
        'Ngày TRON lên sóng, Justin Sun đặt toàn bộ tài sản All In trước ống kính. Từ "vua marketing" của crypto đến chuỗi công cộng top-10 toàn cầu, ông đóng dấu một thời đại bằng hai từ: All In. Hai từ ấy về sau trở thành mật khẩu của cả một thế hệ tín đồ.',
    },
    line: {
      zh: '梭哈点 · 主网上线', en: 'All-In · TRX mainnet launch',
      zhTW: '梭哈點 · 主網上線',
      ja: 'オールインの瞬間 · TRX メインネット稼働',
      ko: '올인 순간 · TRX 메인넷 가동',
      vi: 'Khoảnh khắc All In · TRX mainnet',
    },
    out: {
      zh: '百亿美元公链', en: '$10B+ public chain',
      zhTW: '百億美元公鏈',
      ja: '100億ドル超のパブリックチェーン',
      ko: '100억 달러+ 퍼블릭 체인',
      vi: 'Chuỗi công cộng $10B+',
    },
    image: 'sunyuchen.jpg',
    initial: 'JS',
    surname: {
      zh: '孙宇晨', en: 'Justin Sun',
      zhTW: '孫宇晨', ja: 'ジャスティン・サン', ko: '저스틴 선', vi: 'Justin Sun',
    },
  },
  {
    year: '2017',
    tag: {
      zh: '交易所', en: 'EXCHANGE',
      zhTW: '交易所', ja: '取引所', ko: '거래소', vi: 'SÀN GIAO DỊCH',
    },
    title: {
      zh: '赵长鹏卖房梭哈', en: 'CZ Sells His House',
      zhTW: '趙長鵬賣房梭哈',
      ja: 'CZ、家を売ってオールイン',
      ko: 'CZ, 집을 팔고 올인',
      vi: 'CZ bán nhà để All In',
    },
    body: {
      zh:
        '2014 年，赵长鹏卖掉自己在上海的房子，把全部资金换成比特币。三年后他创办币安，180 天做到全球第一。从开发员到全球最大交易所掌舵人，他赌的不是币价，而是"加密一定会改变金融"这件事。',
      en:
        "In 2014, CZ sold his apartment in Shanghai and put it all into Bitcoin. Three years later he founded Binance — 180 days to global #1. From engineer to top exchange CEO, he never bet on price. He bet on one thesis: crypto will rewire finance.",
      zhTW:
        '2014 年，趙長鵬賣掉自己在上海的房子，把全部資金換成比特幣。三年後他創辦幣安，180 天做到全球第一。從工程師到全球最大交易所掌舵人，他賭的不是幣價，而是「加密一定會改變金融」這件事。',
      ja:
        '2014年、CZ は上海のマンションを売却し、全資金をビットコインに換えた。3年後に Binance を創設し、180日で世界一に。エンジニアから世界最大の取引所のトップへ。彼が賭けたのは価格ではなく、「暗号資産は金融を書き換える」という一つのテーゼだった。',
      ko:
        '2014년, CZ는 상하이의 아파트를 팔고 전 자금을 비트코인으로 바꿨다. 3년 뒤 바이낸스를 창업해 180일 만에 글로벌 1위에 올랐다. 엔지니어에서 세계 최대 거래소의 수장으로. 그가 건 것은 가격이 아니라 "크립토가 금융을 다시 쓴다"는 하나의 테제였다.',
      vi:
        'Năm 2014, CZ bán căn hộ ở Thượng Hải và đổi toàn bộ tiền sang Bitcoin. Ba năm sau, ông sáng lập Binance — 180 ngày trở thành số 1 thế giới. Từ kỹ sư đến CEO sàn lớn nhất, ông không cược vào giá. Ông cược vào một luận đề: crypto sẽ viết lại tài chính.',
    },
    line: {
      zh: '梭哈点 · 卖房梭哈比特币', en: 'All-In · Sold his house for BTC',
      zhTW: '梭哈點 · 賣房梭哈比特幣',
      ja: 'オールインの瞬間 · 家を売ってビットコイン',
      ko: '올인 순간 · 집 팔아 비트코인',
      vi: 'Khoảnh khắc All In · Bán nhà mua BTC',
    },
    out: {
      zh: '全球第一交易所', en: '#1 global exchange',
      zhTW: '全球第一交易所',
      ja: '世界一の取引所',
      ko: '글로벌 1위 거래소',
      vi: 'Sàn giao dịch số 1 toàn cầu',
    },
    image: 'cz.jpg',
    initial: 'CZ',
    surname: { zh: '赵长鹏', en: 'CZ', zhTW: '趙長鵬', ja: 'CZ', ko: 'CZ', vi: 'CZ' },
  },
  {
    year: '1987',
    tag: {
      zh: '通信', en: 'TELECOM',
      zhTW: '通信', ja: '通信', ko: '통신', vi: 'VIỄN THÔNG',
    },
    title: {
      zh: '任正非 43 岁的悬崖创业', en: 'Ren Zhengfei, at 43',
      zhTW: '任正非 43 歲的懸崖創業',
      ja: '43歳の任正非、崖の上の起業',
      ko: '43세 런정페이의 절벽 창업',
      vi: 'Ren Zhengfei khởi nghiệp ở tuổi 43',
    },
    body: {
      zh:
        '从军队转业被骗 200 万，妻离婚、父亲早逝。43 岁的任正非借了 2.1 万人民币，在深圳南油的一间小屋里，创办了华为。他说："华为没有背景，没有资源，惟有奋斗。"这是中国民营科技公司最大的一次梭哈。',
      en:
        'Discharged from the army, swindled out of 2 million. His marriage ended, his father gone. At 43, Ren Zhengfei borrowed 21,000 RMB and founded Huawei in a tiny Shenzhen apartment. "Huawei has no background, no resources — only the struggle." The largest single all-in by any Chinese tech entrepreneur.',
      zhTW:
        '從軍隊轉業被騙 200 萬，妻離婚、父親早逝。43 歲的任正非借了 2.1 萬人民幣，在深圳南油的一間小屋裡，創辦了華為。他說：「華為沒有背景，沒有資源，惟有奮鬥。」這是中國民營科技公司最大的一次梭哈。',
      ja:
        '軍を退役した後、200万元を騙し取られ、妻と離婚、父も亡くなった。43歳の任正非は 2.1 万元を借り、深圳南油の小さなアパートで華為を立ち上げた。「華為には背景もリソースもない。あるのは奮闘だけだ。」中国民営テック企業史上、最大のオールインだった。',
      ko:
        '군에서 전역한 뒤 200만 위안을 사기당했고, 아내와는 이혼했으며 아버지도 일찍 세상을 떠났다. 43세의 런정페이는 2.1만 위안을 빌려 선전 난유의 작은 아파트에서 화웨이를 세웠다. "화웨이엔 배경도 자원도 없다. 오직 분투뿐이다." 중국 민영 테크 기업 역사상 가장 큰 한 방의 올인이었다.',
      vi:
        'Rời quân ngũ, bị lừa 2 triệu nhân dân tệ. Ly hôn vợ, mất cha. Ở tuổi 43, Ren Zhengfei vay 21.000 NDT và lập Huawei trong một căn hộ nhỏ ở Nam Du, Thâm Quyến. "Huawei không có gốc gác, không có tài nguyên — chỉ có nỗ lực." Cú All In lớn nhất của một doanh nhân công nghệ tư nhân Trung Quốc.',
    },
    line: {
      zh: '梭哈点 · 2.1 万元起家', en: 'All-In · 21,000 RMB to start',
      zhTW: '梭哈點 · 2.1 萬元起家',
      ja: 'オールインの瞬間 · 2.1万元で起業',
      ko: '올인 순간 · 2.1만 위안으로 출발',
      vi: 'Khoảnh khắc All In · 21.000 NDT khởi nghiệp',
    },
    out: {
      zh: '全球最大通信巨头', en: 'Largest telecom giant globally',
      zhTW: '全球最大通信巨頭',
      ja: '世界最大の通信企業',
      ko: '세계 최대 통신 거인',
      vi: 'Tập đoàn viễn thông lớn nhất toàn cầu',
    },
    image: 'renzhengfei.jpg',
    initial: 'RZ',
    surname: {
      zh: '任正非', en: 'Ren Zhengfei',
      zhTW: '任正非', ja: '任正非', ko: '런정페이', vi: 'Ren Zhengfei',
    },
  },
  {
    year: '2015',
    tag: {
      zh: '电商', en: 'COMMERCE',
      zhTW: '電商', ja: 'EC', ko: '전자상거래', vi: 'TMĐT',
    },
    title: {
      zh: '黄峥放弃一切重来', en: 'Colin Huang Restarts',
      zhTW: '黃崢放棄一切重來',
      ja: 'コリン・ホアン、全てを捨てて再起動',
      ko: '콜린 황, 모든 것을 버리고 재시작',
      vi: 'Colin Huang khởi động lại từ đầu',
    },
    body: {
      zh:
        '已经做过游戏、电商、代运营三家公司，35 岁的黄峥又一次清空，梭哈一个被所有人嘲笑的赛道——下沉市场社交电商。三年上市，五年市值超过京东。"保持常识，远离喧嚣。"他赌的是中国底层 5 亿人的购买力。',
      en:
        'After three companies — gaming, e-commerce, agency — Colin Huang reset again at 35. He went all in on a track everyone laughed at: social commerce in lower-tier China. IPO in three years. Market cap above JD.com in five. "Keep common sense. Stay far from the noise." He bet on the buying power of 500M ordinary Chinese.',
      zhTW:
        '已經做過遊戲、電商、代運營三家公司，35 歲的黃崢又一次清空，梭哈一個被所有人嘲笑的賽道——下沉市場社交電商。三年上市，五年市值超過京東。「保持常識，遠離喧囂。」他賭的是中國底層 5 億人的購買力。',
      ja:
        'ゲーム、EC、運用代行と三社を起業した後、35 歳のコリン・ホアンは再びゼロからやり直し、誰もが嘲笑した賽道——下沈市場のソーシャル EC——にオールインした。三年で上場、五年で時価総額が JD.com を超える。「常識を保ち、喧騒から遠ざかる。」彼は中国底層5億人の購買力に賭けた。',
      ko:
        '게임, 전자상거래, 운영 대행 등 세 회사를 세운 뒤, 35세의 콜린 황은 다시 한 번 모든 것을 비우고 모두가 비웃은 트랙 — 하층 시장 소셜 커머스 — 에 올인했다. 3년 만에 상장, 5년 만에 시총이 JD.com을 넘었다. "상식을 유지하고 소란에서 멀어져라." 그가 건 것은 중국 5억 보통 사람들의 구매력이었다.',
      vi:
        'Sau ba công ty — game, TMĐT, đại lý vận hành — Colin Huang ở tuổi 35 lại reset từ đầu, đặt tất cả vào một con đường ai cũng cười: TMĐT mạng xã hội ở thị trường hạ cấp. IPO sau ba năm. Vốn hóa vượt JD.com sau năm năm. "Giữ thường thức, tránh xa ồn ào." Ông cược vào sức mua của 500 triệu người Trung Quốc bình dân.',
    },
    line: {
      zh: '梭哈点 · 三年上市', en: 'All-In · IPO in three years',
      zhTW: '梭哈點 · 三年上市',
      ja: 'オールインの瞬間 · 3年で上場',
      ko: '올인 순간 · 3년 만에 상장',
      vi: 'Khoảnh khắc All In · IPO sau ba năm',
    },
    out: {
      zh: '两千亿美元峰值', en: '$200B peak market cap',
      zhTW: '兩千億美元峰值',
      ja: '時価総額ピーク2,000億ドル',
      ko: '시총 정점 2,000억 달러',
      vi: 'Đỉnh vốn hóa $200B',
    },
    image: 'huangzheng.jpg',
    initial: 'CH',
    surname: {
      zh: '黄峥', en: 'Colin Huang',
      zhTW: '黃崢', ja: 'コリン・ホアン', ko: '콜린 황', vi: 'Colin Huang',
    },
  },
  {
    year: '2001',
    tag: {
      zh: '投资', en: 'INVESTING',
      zhTW: '投資', ja: '投資', ko: '투자', vi: 'ĐẦU TƯ',
    },
    title: {
      zh: '段永平的两次世纪梭哈', en: 'Two Bets That Defined a Decade',
      zhTW: '段永平的兩次世紀梭哈',
      ja: '段永平、世紀の二度のオールイン',
      ko: '돤융핑, 세기의 두 번의 올인',
      vi: 'Hai cú đặt định nghĩa một thập kỷ',
    },
    body: {
      zh:
        '2001 年互联网泡沫，网易股价从 15 跌到 0.6 美元，无人敢碰。段永平梭哈 200 万美元——三年回报 50 倍。十年后乔布斯去世市场恐慌，他再次梭哈苹果，又是 10 年 10 倍。"不为清单"是他的信条：看不懂的不碰，看懂了不要小注。',
      en:
        "In 2001 NetEase fell from $15 to $0.6 in the dot-com crash — untouchable. Duan Yongping bet $2M. Three years, 50x. A decade later when Steve Jobs died and the market panicked, he bet on Apple again. Ten years, 10x. \"Stop-doing list\" is his creed: don't touch what you don't understand. When you do, don't bet small.",
      zhTW:
        '2001 年網路泡沫，網易股價從 15 跌到 0.6 美元，無人敢碰。段永平梭哈 200 萬美元——三年回報 50 倍。十年後賈伯斯去世市場恐慌，他再次梭哈蘋果，又是 10 年 10 倍。「不為清單」是他的信條：看不懂的不碰，看懂了不要小注。',
      ja:
        '2001 年のドットコム崩壊で、NetEase は 15 ドルから 0.6 ドルへ。誰も手を出せなかった。段永平は 200 万ドルでオールイン——3年で 50 倍。10 年後、ジョブズの死で市場が恐慌に陥ったとき、彼は再び Apple にオールイン。10 年で 10 倍。「やらないリスト」が彼の信条だ：理解できないものには触れない、理解したら小さく賭けない。',
      ko:
        '2001년 닷컴 붕괴 때 NetEase는 15달러에서 0.6달러로 떨어졌다 — 아무도 손대지 않았다. 돤융핑은 200만 달러로 올인했다 — 3년 만에 50배. 10년 뒤 스티브 잡스가 떠나고 시장이 패닉에 빠졌을 때, 그는 다시 애플에 올인했다 — 10년 만에 10배. "하지 않을 목록"이 그의 신조다: 이해 못 하는 건 손대지 마라. 이해했다면 작게 걸지 마라.',
      vi:
        'Năm 2001 bong bóng dot-com, NetEase rơi từ 15 xuống 0,6 USD — không ai dám động vào. Duan Yongping đặt 2 triệu USD — ba năm tăng 50 lần. Một thập kỷ sau, khi Steve Jobs mất và thị trường hoảng loạn, ông lại All In vào Apple — mười năm tăng 10 lần. "Danh sách không làm" là tín điều của ông: không hiểu thì không động, hiểu rồi thì đừng đặt nhỏ.',
    },
    line: {
      zh: '梭哈点 · 网易 0.6 美元抄底', en: 'All-In · NetEase at $0.6',
      zhTW: '梭哈點 · 網易 0.6 美元抄底',
      ja: 'オールインの瞬間 · NetEase 0.6 ドルで底値拾い',
      ko: '올인 순간 · NetEase 0.6달러 바닥잡기',
      vi: 'Khoảnh khắc All In · NetEase ở $0,6',
    },
    out: {
      zh: '中国巴菲特', en: "China's Buffett",
      zhTW: '中國巴菲特',
      ja: '中国のバフェット',
      ko: '중국의 버핏',
      vi: 'Buffett Trung Quốc',
    },
    image: 'duanyongping.jpg',
    initial: 'DY',
    surname: {
      zh: '段永平', en: 'Duan Yongping',
      zhTW: '段永平', ja: '段永平', ko: '돤융핑', vi: 'Duan Yongping',
    },
  },
];
